import { Injectable } from '@angular/core';
import { FlowService } from '@services/flow.service';
import { ConfigType, ProcessFlowDto } from '@swagger-services/flow';

@Injectable()
export class PreVisitFlowService extends FlowService {
  override processFlow(data?: Partial<ProcessFlowDto>): Promise<any> {
    const payload: ProcessFlowDto = {
      configType: ConfigType.PreVideoVisit,
      id: this.flowConfig?.id,
      currentStep: this.flowConfig?.nextStep || this.flowConfig?.currentStep,
      ...data,
    };
    return super.process(payload);
  }

  startFlow(id: string): Promise<any> {
    return super.process({
      id,
      configType: ConfigType.PreVideoVisit,
    });
  }

  override redirectUserToNextStep(): void {}
}
